<template>
    <div>
        <aside class="control-sidebar control-sidebar-light">
            <ul class="nav navbar-stacked">
                <li></li>
                <li v-for="(auditLog, index) in auditLogs">
                  <svg aria-hidden="true" height="20px" width="20px" data-prefix="fal" data-icon="user-plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="svg-inline--fa fa-user-plus fa-w-20 fa-2x"><path fill="currentColor" d="M640 252v8c0 6.627-5.373 12-12 12h-68v68c0 6.627-5.373 12-12 12h-8c-6.627 0-12-5.373-12-12v-68h-68c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h68v-68c0-6.627 5.373-12 12-12h8c6.627 0 12 5.373 12 12v68h68c6.627 0 12 5.373 12 12zm-264.942 32.165l-43.497-12.428C355.115 245.342 368 211.663 368 176c0-79.525-64.339-144-144-144-79.525 0-144 64.339-144 144 0 35.663 12.885 69.342 36.439 95.737l-43.497 12.428C17.501 300.005 0 350.424 0 380.866v39.705C0 453.34 26.66 480 59.429 480h329.143C421.34 480 448 453.34 448 420.571v-39.705c0-57.659-43.675-88.339-72.942-96.701zM224 64c61.856 0 112 50.144 112 112s-50.144 112-112 112-112-50.144-112-112S162.144 64 224 64zm192 356.571C416 435.72 403.72 448 388.571 448H59.429C44.28 448 32 435.72 32 420.571v-39.705c0-30.616 20.296-57.522 49.733-65.933l63.712-18.203C168.611 311.87 195.679 320 224 320s55.389-8.13 78.555-23.27l63.712 18.203C395.704 323.344 416 350.251 416 380.866v39.705z" class=""></path></svg>
                </span>&nbsp
                <strong>{{`${(auditLog.user)?auditLog.user.first_name:''}`}} {{ auditLog.action | action }}&nbsp</strong>
                {{ (auditLog.obj) ? (auditLog.obj.name) : '' }} {{ `${auditLog.action == 'PUBLISHED_SNIPPET' || auditLog.action == 'ADDED URL BLOCK' ? auditLog.extra.info:''}`}}
                {{ (auditLog.action.indexOf('HB_TAG') > -1 && auditLog.obj) ? 'for the domain ' + auditLog.obj.domain.name : ''}}
                      <div>
                        at <small>{{ `${auditLog.timestamp}` | moment("'MMM Do YYYY, h:mm:ss a") }}</small>
                      </div>
                      <br v-if="index == (auditLogs.length - 1)">
                </li>
            </ul>
            <!-- <infinite-loading spinner="waveDots" @infinite="infiniteHandler"></infinite-loading> -->
        </aside>
        <!-- /.control-sidebar -->
        <!-- Add the sidebar's background. This div must be placed
            immediately after the control sidebar -->
    </div>
</template>
<script>
    import axios from 'axios'
    import { EventBus } from '../../event-bus.js';

    export default {
      data() {
          return {
              auditLogs: [],
              name: '',
              current_page: 1
          };
      },
      mounted: function () {
        console.log('Control sidebar mounted');
        EventBus.$on('update_logs', () => {
          console.log(`update_logs event caught!!!`);
          // this.fetchLogs();
        });
      },
      name: 'ControlSidebar',
      created: function(){
          this.fetchLogs();
      },
    	filters: {
    	    action: function (value) {
    	      if (!value) return ''
    	      	let action = value;
    	      	action = action.toLowerCase();
    	      	action = action.split('_').join(' ');
    	      return action
    	    }
    	},
        methods: {
          fetchLogs(){
            axios.get(BASE_URL + `v1/audit-log/?limit=20&offset=0&domain_id=${this.$route.params.domId}`)
              .then((response) => {
                      console.log(response.data.results)
                      this.auditLogs = response.data.results;
              })
              .catch(function (err) {
                  console.log('Error', err)
              })

            $(document).ready(function ($) {
              $('.navbar-stacked').slimScroll({
                position: 'right',
                size: '3px',
                height: '95vh'
              })
            })
          },
          infiniteHandler($state) {
              axios.get(BASE_URL + 'v1/audit-log/', {
              params: {
                limit: 20,
                offset: (this.current_page - 1)
              },
            }).then(({ data }) => {
              console.log(data);
              if (data.results.length) {
                this.current_page += 1;
                this.auditLogs.push(...data.results);
                $state.loaded();
              } else {
                $state.complete();
              }
            });
          },
        }
    }
</script>
<style scoped>
.nav.navbar-stacked li a {
  line-height: 30px !important;
}
.nav.navbar-stacked{
  color: #5e5e5e;
  background: #f9fafc;
  border-left: 1px solid #d2d6de;
  width: 100%;
}
</style>
<style lang="scss">
    /* Off Canvas settings */
    .off-canvas.position-right {
    border-left: 1px solid #ddd;
    }
    .nav.navbar-stacked {
    overflow: hidden;
    padding: 0;
    margin: 0;
    list-style: none;
    position: fixed;
    li {
    border-bottom: 1px solid rgba(76,74,74,0.1);
    position: relative;
    padding: 15px 10px 15px 35px;
    border-bottom: 1px solid rgba(76,74,74,0.1);
    position: relative;
    a {
    padding: 10px 0 !important;
    color: #555 !important;
    text-indent: -40px;
    margin-left: 25px;
    display: block;
    span {
    color: #fff;
    border-radius: 50%;
    line-height: 30px;
    text-align: center;
    margin: 0 10px 0 0;
    padding: 8px;
    }
    i {
    color: #ccc;
    font-size: 10px !important;
    position: relative;
    left: -5px;
    }
    small {
    text-align: right;
    background: #fff;
    color: #000;
    border: 1px solid #ddd;
    padding: 5px 10px;
    border-radius: 15px;
    margin: 0 0 0 7px;
    font-size: 11px;
    letter-spacing: 0.5px;

    }
    img {
    width: 95%;
    padding: 0;
    border-radius: 4px;
    margin: 10px 0;
    }
    }
    }
    &.sidebar-right-content {
    padding-bottom: 150px;
    }
    }
</style>


// WEBPACK FOOTER //
// ControlSidebar.vue?10359129